<template>
  <div>
    <protocol-header v-if="protocol && !readonly"
                     :protocol="protocol"
                     :task="task"></protocol-header>
    
    <amendment-header v-if="amendment && !readonly"
                      :amendment="amendment"></amendment-header>
    
    <div class="row">
      <div class="col-12">
        <div class="card-header">
          <h1 class="card-title mb-0">{{ task.classification.title }}</h1>
        </div>
        
        <div class="card">
          <div class="card-body">
            <div class="nav-scroller border-bottom">
              <div class="nav nav-tabs">
                <a class="nav-link active" href="#amendment-data" data-toggle="tab">Datos de enmienda</a>
                <a class="nav-link" href="#attachments" data-toggle="tab">Incorporar anexos a la solicitud</a>
              </div>
            </div>
            
            <div class="tab-content pt-4">
              <div class="tab-pane fade show active" id="amendment-data" role="tabpanel">
                <form method="post" onsubmit="return false" ref="form"
                      v-if="amendment">
                  
                  <div class="form-group">
                    <researchers-list :researchers="currentResearchers"
                                      :protocol="protocol"
                                      :show-header="true"
                                      :readonly="readonly"
                                      ref="researchers-list"
                                      @add-researcher="showUsersModal"
                                      @remove-researcher="removeResearcher"></researchers-list>
                  </div>
                  <div class="form-group">
                    <external-researchers-list :researchers="currentExternalResearchers"
                                               :protocol="protocol"
                                               :show-header="true"
                                               :readonly="readonly"
                                               ref="external-researchers-list"
                                               @remove-researcher="removeResearcher"></external-researchers-list>
                  </div>
                  
                  <div class="form-group" v-if="!readonly">
                    <button type="button" class="btn btn-lg btn-outline-primary"
                            data-toggle="modal"
                            data-target="#users-modal"
                            @click="$refs['users-modal'].load()">Agregar coinvestigador
                    </button>
                  </div>
                  
                  <div class="d-flex" v-if="!readonly">
                    <button type="button"
                            class="btn btn-primary btn-lg mr-3"
                            @click.prevent="saveAmendment"
                            :disabled="saving">
                      <spinner small class="text-white" v-if="saving"></spinner>
                      {{ amendment ? 'Actualizar' : 'Guardar' }}
                    </button>
                    
                    <button type="button"
                            class="btn btn-dark btn-lg"
                            :class="{'d-none': !researchersInvitedAccepted}"
                            v-if="amendment.updated && researchersInvitedAccepted"
                            :disabled="saving"
                            data-toggle="modal"
                            data-target="#send-amendment-modal">
                      <i class="fas fa-paper-plane mr-2"></i> Enviar enmienda a revisión
                    </button>
                    
                    <button type="button"
                            class="btn btn-danger btn-lg ml-auto"
                            :disabled="saving"
                            data-toggle="modal"
                            data-target="#delete-amendment-modal">Eliminar
                    </button>
                  </div>
                </form>
              </div>
              
              <div class="tab-pane fade" id="attachments" role="tabpanel">
                <div class="page-section">
                  <div class="section-block m-0 p-0">
                    <div class="row">
                      <div class="col">
                        <p class="font-weight-bold mt-0"
                           v-if="amendment && amendment.attachments && amendment.attachments.length">
                          Anexos agregados
                        </p>
                        
                        <files-list v-if="selectedAmendment"
                                    :model="selectedAmendment"
                                    :files="selectedAmendment.attachments"
                                    :save-files-function="saveAttachments"
                                    @delete-file="deleteAttachment"
                                    :readonly="readonlyFiles"></files-list>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <portal to="task-modals">
        <ok-cancel-dialog title="Eliminar enmienda"
                          id="delete-amendment-modal"
                          ref="delete-amendment-modal"
                          content="<p>¿Esta seguro eliminar la enmienda?</p>"
                          ok-button-text="Confirmar"
                          :ok-callback="deleteAmendment"></ok-cancel-dialog>
        
        <ok-cancel-dialog title="Enviar enmienda a revisión"
                          id="send-amendment-modal"
                          ref="send-amendment-modal"
                          content="<p>¿Esta seguro de enviar la enmienda a revisón?</p>"
                          ok-button-text="Confirmar"
                          :ok-callback="sendAmendmentToEvaluation"></ok-cancel-dialog>
        
        <file-modal id="file-modal"
                    multiple
                    title="Adjuntar anexos"
                    :save-files-function="saveAttachments"></file-modal>
        
        <users-modal ref="users-modal"
                     :selected-users="currentResearchers"
                     :load-users-function="getResearchers"
                     @user-selected="addResearcher"
                     :amendment="amendment"></users-modal>

        <external-users-modal ref="external-users-modal"
                              :amendment="amendment"></external-users-modal>
      </portal>
    </div>
  </div>
</template>
<script>
  import autosize from 'autosize'
  import 'jquery-validation'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import Spinner from '../ui/Spinner'
  import ProtocolHeader from '../protocols/ProtocolHeader'
  import AmendmentHeader from './AmendmentHeader'
  import FileModal from '../ui/FileModal'
  import FilesList from '../protocols/FilesList'
  import UsersModal from '../users/UsersModal'
  import ExternalUsersModal from '../users/ExternalUsersModal'
  import ResearchersList from './ResearchersList'
  import ExternalResearchersList from './ExternalResearchersList'
  
  export default {
    name: 'AmendmentResearchers',
    components: {
      OkCancelDialog,
      ProtocolHeader,
      AmendmentHeader,
      Spinner,
      FileModal,
      FilesList,
      UsersModal,
      ExternalUsersModal,
      ResearchersList,
      ExternalResearchersList,
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
      amendment: Object,
      committee: Object,
      readonly: {
        type: Boolean,
        default: false,
      },
      readonlyFiles: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        editing: false,
        saving: false,
        file: null,
        researcher: null,
      }
    },
    methods: {
      ...mapActions({
        saveProtocolAmendment: 'amendments/saveAmendment',
        saveAmendmentAttachments: 'amendments/saveAttachments',
        deleteProtocolAmendment: 'amendments/deleteAmendment',
        removeAttachmentFromAmendment: 'amendments/removeAmendmentAttachment',
        sendAmendment: 'amendments/sendAmendmentToEvaluation',
        getResearchers: 'users/getResearchers',
        setNewProtocolUser: 'amendments/setNewProtocolUser',
        getProtocolResearchers: 'protocols/getProtocolResearchers',
        addResearcherToProtocol: 'amendments/addResearcher',
        getAmendmentResearchers: 'amendments/getAmendmentResearchers',
        removeResearcherFromAmendment: 'amendments/removeResearcherFromAmendment',
        removeExternalResearcher: 'protocols/removeExternalResearcher',
      }),
      
      ...mapMutations({
        setAmendment: 'amendments/SET_AMENDMENT',
        setProtocol: 'protocols/SET_SELECTED_PROTOCOL',
      }),
      
      async removeResearcher (researcher) {
        console.log({ researcher })
        console.log(this.protocolResearchers, this.protocolExternalResearchers)
        // If researcher is not in protocols researchers, then deleted.
        if (this.protocolResearchers.findIndex(r => r.id === researcher.id) === -1
          && this.protocolExternalResearchers.findIndex(r => r.id === researcher.id) === -1) {
          const response = researcher.invited_by_email
            ? await this.removeExternalResearcher({
                protocol: this.amendment.protocol.id,
                invitation: researcher.id,
              })
            : await this.removeResearcherFromAmendment({
                amendment: this.amendment,
                researcher,
              })
  
          console.log({ response })
          
          const { error, status, message } = researcher.invited_by_email
            ? response
            : response.data.data
          
          if (status === 'error') {
            AlertManager.error(error)
            
            return false
          }
          
          // Reload researchers.
          await this.getAmendmentResearchers(this.amendment)
  
          await this.getProtocolResearchers({
            protocol: this.amendment.protocol,
            status: 'aceptado',
          })
        }
      },
      
      async saveAttachments (files) {
        const formData = new FormData()
        
        files.forEach(file => {
          formData.append('files[]', file.file)
        })
        
        formData.append('amendment', this.amendment.id)
        formData.append('type', this.amendment.type.key)
        
        const response = await this.saveAmendmentAttachments(formData)
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        $(`#attachments-modal`).modal('hide')
      },
      async deleteAttachment (file, callback) {
        const response = await this.removeAttachmentFromAmendment({
          amendment: this.amendment,
          file,
        })
        
        if (response.status === 'success') {
          AlertManager.success(response.message)
        }
        else {
          AlertManager.error(response.error)
        }
        
        callback(response)
      },
      async deleteAmendment () {
        this.saving = true
        
        const response = await this.deleteProtocolAmendment({
          amendment: this.amendment,
        })
        
        this.saving = false
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        this.$emit('close-task')
      },
      async sendAmendmentToEvaluation () {
        const response = await this.sendAmendment({
          amendment: this.amendment,
          committee: this.committee,
        })
        
        if (response.data.data.status === 'success') {
          return location.href = `/redirect?url=${encodeURIComponent(location.origin)}&message=${encodeURIComponent(response.data.data.message)}`
        }
        
        AlertManager.error(response.data.data.error)
      },
      showUsersModal () {
        this.$refs['users-modal'].clearSearch()
        this.$refs['users-modal'].load()
      },
      async addResearcher (user, callback) {
        const response = await this.addResearcherToProtocol({
          amendment: this.amendment,
          researcher: user.id,
        })
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
        }
        
        AlertManager.success(message)
        
        this.$refs['users-modal'].close()

        this.researcher = response.data.data.researcher
        
        if (callback) {
          callback(response)
        }
  
        await this.getAmendmentResearchers(this.amendment)
  
        await this.getProtocolResearchers({
          protocol: this.amendment.protocol,
          status: 'aceptado',
        })
        
        this.amendment.updated = false
      },
      async saveAmendment () {
        if (!$(this.$refs.form).valid()) {
          return false
        }
        
        // Check if all textarea are filled.
        const $textarea = $('textarea:enabled', this.$el)
        let valid       = true
        
        // Remove invalid class first.
        $textarea.removeClass('is-invalid')
        
        for (let i = 0, len = $textarea.length; i < len; i += 1) {
          if ($($textarea[i]).val() === '') {
            $($textarea[i]).addClass('is-invalid')
            valid = false
          }
        }
        
        if (!valid) {
          AlertManager.error('Especifique las justificaciones para agregar/eliminar coinvestigadores.')
          
          return false
        }
        
        this.saving = true
        
        const {
                end_date,
                new_financing,
                justification,
                type,
              } = this.amendment
        
        const response = await this.saveProtocolAmendment({
          amendment: this.amendment,
          justification,
          researchers: [...this.currentResearchers, ...this.currentExternalResearchers],
          end_date,
          new_financing,
          type,
        })
        
        this.saving = false
        
        const {
                error,
                status,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        // Update updated flag.
        this.amendment.updated = true
        
        AlertManager.success(message)
      },
    },
    computed: {
      ...mapGetters({
        selectedAmendment: 'amendments/selectedAmendment',
        protocolResearchers: 'protocols/researchers',
        protocolExternalResearchers: 'protocols/externalResearchers',
        researchers: 'amendments/researchers',
        externalResearchers: 'amendments/externalResearchers',
      }),
      
      currentResearchers () {
        this.protocolResearchers.map(researcher => {
          researcher.added_on_protocol = true
          
          return researcher
        })
        
        this.researchers.map(researcher => {
          researcher.added_on_amendment = true
          
          return researcher
        })
        
        // Remove researchers that were removed in this amendment from protocolsResearchers.
        const researchers = this.protocolResearchers.filter(researcher => {
          const r = this.researchers.find(r => r.id === researcher.id)
          
          if (!r) {
            return researcher
          }
        })
        
        return [...this.researchers, ...researchers]
      },

      currentExternalResearchers () {
        this.protocolExternalResearchers.map(researcher => {
          researcher.added_on_protocol = true
          
          return researcher
        })
        
        this.externalResearchers.map(researcher => {
          researcher.added_on_amendment = true
          
          return researcher
        })
        
        // Remove researchers that were removed in this amendment from protocolsResearchers.
        const researchers = this.protocolExternalResearchers.filter(researcher => {
          const r = this.externalResearchers.find(r => r.id === researcher.id)
          
          if (!r) {
            return researcher
          }
        })
        
        return [...this.externalResearchers, ...researchers]
      },
  
      researchersInvitedAccepted() {
        const pending = this.currentResearchers.filter(researcher => {
          if (researcher.added_on_amendment && (researcher.pivot.status.key === 'enviado' || !researcher.pivot.justification)) {
            return true
          }
        })

        const externalPending = this.currentExternalResearchers.filter(researcher => {
          if (researcher.added_on_amendment
            && !researcher.invited_by_email
            && (researcher.status.key === 'enviado'  || !researcher.pivot.justification)) {
            return true
          }

          if (researcher.added_on_amendment
            && researcher.invited_by_email
            && researcher.is_accepted === null) {
            return true
          }
        })

        return pending.length === 0 && externalPending.length === 0
      }
    },
    async mounted () {
      this.setAmendment(this.amendment)
      this.setProtocol(this.amendment.protocol)
      
      if (this.readonly) {
        $('#amendment-data', this.$el).find('input, :radio, :checkbox, textarea, button').prop('disabled', true)
      }
      
      autosize(document.getElementById('comments'))
      
      await this.getAmendmentResearchers(this.amendment)
      
      await this.getProtocolResearchers({
        protocol: this.amendment.protocol,
        status: 'aceptado',
      })
    },
  }
</script>
